import React from "react";
import "./StyleError.css";
// import { useMoralis } from "react-moralis";
import { useContext } from "react";
import { WalletContext } from "../Context/noteContext";
// import { useAuthContext } from "../../AuthContext";
import { motion } from "framer-motion";

function Error1({ text, close, errImage, switchButton, backImg }) {
  const {
    // walletConnection,
    setWalletConnection,
  } = useContext(WalletContext);
  // const { setErrorState } = useAuthContext();
  const polyNet = {
    chainId: `0x${Number(137).toString(16)}`,
    chainName: "Polygon Mainnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    rpcUrls: ["https://polygon-rpc.com/"],
    blockExplorerUrls: ["https://polygonscan.com"],
  };

  // const { Moralis } = useMoralis();
  const networkSwith = async (networkName) => {
    try {
      if (!window.ethereum) throw new Error("Wallet not found");
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            ...polyNet,
            networkName,
          },
        ],
      });
      setWalletConnection(true);
      // setErrorState(false)
    } catch (error) {
      // console.log("Meta error",error.message);
    }
  };
  // console.log("wallet connection", errImage);
  return (
    <div
      
    >
      <main className="error-main">
        <section className={`error-sec h-100 my-auto ${backImg}`}>
          <div className="container h-100">
            <div className="row">
              <div className="col-md-12">
                <div className="error-content">
                  <span className="error-cancel">
                    <img
                      src={require("./images/cancel-error-popup.png")}
                      alt="cancel"
                      onClick={close}
                    />
                  </span>
                  <div className="error-img">
                    <img
                      src={require("./images/error-loader-img.png")}
                      alt="error"
                    />
                  </div>
                  <div className="error-desc">
                    <h2>{text.message || text}</h2>
                  </div>
                  <div className="error-img2">
                    <img src={errImage.gaming || errImage} alt="wallet" />
                  </div>
                  <div className="error-btn">
                    {switchButton === true ? (
                      <button
                        onClick={() => {
                          networkSwith();
                        }}
                      >
                        Switch to polygon
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Error1;
